<table [formGroup]="parentFormGroup" >
  <thead>
    <tr>
      <th class="text-center" *ngIf="check || order"></th>
      <th class="text-center">Código</th>
      <th class="title">Indicador</th>
      <th class="text-center">Polar.</th>
      <th class="text-center">Medida</th>
      <th class="text-center">Meta</th>
      <th class="text-center">Realizado</th>
      <th class="text-center">Apuração</th>
      <th class="text-center">Status</th>
      <th class="text-center">Projeção</th>
      <th class="text-center">PC</th>
      <th class="text-center" *ngIf="expand == true"></th>
    </tr>
  </thead>
  <tbody formArrayName="acIndicators" cdkDropList [cdkDropListDisabled]="!order"
  (cdkDropListDropped)="order ? onOrderItem($event) : null">
    <ng-container *ngFor="let ind of acIndicators?.controls; let i_i = index"  [formGroupName]="i_i">
      <tr *ngIf="currentItem[i_i] as variable" class="tr-{{i_i % 2}}" cdkDrag  cdkDragLockAxis="y">
        <td class="text-center" *ngIf="check">
          <input type="checkbox" class="ms-2" [checked]="variable?.checkeds" formControlName="checkeds" (change)="onCheckStatus()"/>
        </td>
        <td class="text-center" *ngIf="order">
          <div class="drag-handle">
            <img src="assets/images/svgs/menu.svg" alt="Mover" tooltip="Mover" placement="bottom">
          </div>
        </td>
        <td class="text-center">{{variable?.id}}</td>
        <td class="">{{variable?.title}} 
          <span *ngIf="variable?.ind_type == 2">{{variable?.son_name}}</span>
        </td>
        <td class="text-center">
          <div class="dot-arrow dot-arrow-{{variable?.polarity? 1:3}}"></div>
        </td>
        <td class="text-center">{{variable?.unit_id}}</td>
        <td class="text-center">
          <span>{{(variable?.current_goal | number:'1.0-2') ?? 'NI'}}</span>
        </td>
        <td class="text-center">
          <span>{{(variable?.current_done | number:'1.0-2') ?? 'NI'}}</span>
        </td>
        <td class="text-center">{{variable?.acIndTable}}</td>
        <td class="text-center">
          <div class="dot dot-{{variable?.current_table_status ?? 0}}"></div>
        </td>
        <td class="text-center">
          <div class="dot dot-arrow dot-arrow-{{variable?.ind_analysis_stat_id ?? 0}}"></div>
        </td>
        <td class="text-center text-danger">{{variable?.total_pc}}</td>
        <td class="text-center" *ngIf="expand == true">
          <span class="icon-table icon-button" *ngIf="variable?.analysis_description" (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true">
            <img src="assets/images/svgs/lupa{{variable?.show_description?'-menos':''}}.svg" alt="Consultar" tooltip="Consultar" placement="bottom">
          </span>
        </td>
      </tr>
      <tr *ngIf="currentItem[i_i]['show_description'] == true">
        <td colspan="12"  class="break-word td-description">{{currentItem[i_i]['analysis_description'] }}</td>
      </tr>
    </ng-container>
  </tbody>
</table>